import * as navigation from 'Navigation';

export default class RunResultsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Legacy Results',
      closeable: false,
      preferenceKey: 'run-results',
    };
  }
}
